import { Typography, styled } from '@mui/material';

export const GroupItems = styled('ul')(() => ({
  padding: 0,
}));

export const OverlineText = styled(Typography)(() => ({
  paddingLeft: 2,
}));
